import MtBreadcrumb from './MtBreadcrumb' // 折叠面板
import MtTable from './MtTable'
import MtWindow from './MtWindow'
import MtForm from './MtForm'
import MtButton from './MtButton'
import MtFormItem from './MtFormItem'
import MtHamburger from './MtHamburger'
import MtInputNumber from './MtInputNumber'
import MtSvgIcon from './MtSvgIcon'
import MtUploadImage from './MtUploadImage'
import MtDataContent from './MtDataContent'
import MtEditContent from './MtEditContent'
import MtSearchContent from './MtSearchContent'
import MtBack from './MtBack'





const components = [
  MtTable,
  MtWindow,
  MtForm,
  // MtTimePicker,
  // MtTimeSelect
  MtButton,
  MtBreadcrumb,
  MtFormItem,
  MtHamburger,
  MtInputNumber,
  MtSvgIcon,
  MtUploadImage,
  MtDataContent,
  MtEditContent,
  MtSearchContent,
  MtBack,
  
]

const install = function (Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component)
  })
}

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  MtTable,
  MtWindow,
  MtForm,
  MtButton,
  MtBreadcrumb,
  MtFormItem,
  MtHamburger,
  MtInputNumber,
  MtSvgIcon,
  MtUploadImage,
  MtDataContent,
  MtEditContent,
  MtSearchContent,
  MtBack,
  
}


// WEBPACK FOOTER //
// ./src/components/Mt/index.js